import { Form } from 'antd'
import { FormInstance } from 'antd/lib'

import {
  InquiryDocumentResponse,
  IssuanceDocumentResponse
} from 'src/api/requests'
import { ConsumableListCreate } from 'src/features/stock/components'

import { AdminConsumableTable } from './AdminConsumableTable'

type Props = {
  isEdit: boolean
  isSubmitted?: boolean
  data?: IssuanceDocumentResponse
  issuanceData?: InquiryDocumentResponse
  form: FormInstance
}

export const AdminConsumableList = ({
  isEdit,
  isSubmitted,
  data,
  issuanceData,
  form
}: Props) => {
  return (
    <>
      {data && (
        <Form.Item name="inquiryItems">
          <ConsumableListCreate
            form={form}
            isFinished={true}
            issuanceData={issuanceData}
          />
        </Form.Item>
      )}

      {isEdit && (
        <Form.Item name="medicine">
          <Form.List name="medicine">
            {(fields, { add, remove }) => (
              <AdminConsumableTable
                issuanceData={issuanceData}
                data={data}
                form={form}
                isSubmitted={isSubmitted}
                fields={fields}
                add={add}
                remove={remove}
              />
            )}
          </Form.List>
        </Form.Item>
      )}
    </>
  )
}
